import { Tab } from '@models/company/tab';

export class CustomTab extends Tab {}
